/*
 * @Author: Src
 * @Date: 2024-12-29 16:30:01
 * @LastEditTime: 2026-08-05 11:47:26
 * @LastEditors: Src
 * @FilePath: /work-station/src/common/utils/permission-manager.ts
 * @Description: 权限管理
 */
import { BehaviorSubject, from, throttleTime, distinctUntilChanged, mergeMap, Subject } from 'rxjs';
import { BASE_URL } from '@/common/constant/index';
import axios from 'axios';
import { message } from 'ant-design-vue';

class PermissionManager {
  private eventsMap: Map<string, any>;

  private resultMap: Map<string, any>;

  public constructor() {
    this.eventsMap = new Map();
    this.resultMap = new Map();
  }

  private getData(names: string) {
    const nameList = names.split(',').map((n) => n.trim());
    const userStorage = localStorage.getItem('user');
    const AUTHORIZATION = userStorage ? JSON.parse(userStorage).token : null;
    const permissionStorage: any = localStorage.getItem('permission') || '{}';

    const permissionMap = new Map();
    const parsedCache = JSON.parse(permissionStorage);
    for (const [key, val] of Object.entries(parsedCache)) {
      permissionMap.set(key, val);
    }

    const nowSeconds = Math.floor(Date.now() / 1000);
    const result: any = {}; // 用于收集所有结果（缓存+接口）
    const missingNames: string[] = [];

    nameList.forEach((name) => {
      if (!name) return;
      const cachedItem = permissionMap.get(name);
      // && cachedItem.expired > nowSeconds
      if (cachedItem) {
        result[name] = cachedItem.value; // 先放入结果集
      } else {
        missingNames.push(name); // 收集需要请求的
      }
    });

    if (missingNames.length === 0) {
      // 复用你要求的核心写法
      return new Promise((resolve) => {
        resolve(result);
      });
    }

    const item = axios.post(`${BASE_URL}/rbac/permission/list`, {
      loadingEl: document.body,
      permission_name: missingNames.join(','),
    }, {
      headers: {
        AUTHORIZATION,
      },
    });

    return new Promise((resolve, reject) => {
      item.then((res) => {
        const newData = res as any; // 假设返回 { "c": true }
        const currentCache = JSON.parse(localStorage.getItem('permission') || '{}');
        Object.keys(newData).forEach((key) => {
          currentCache[key] = {
            value: newData[key],
            expired: nowSeconds + 60 * 60 * 24,
          };
        });
        localStorage.setItem('permission', JSON.stringify(currentCache));

        Object.assign(result, newData);
        resolve(result);
      }).catch((err) => {
        if (err.response.status === 401) {
          message.error('登录已过期，请重新登录');
          window.location.hash = '#/login';
          location.reload();
        }
        reject(err);
      });
    });
  }

  public send(namesList: string[]) {
    const names = namesList.join(',');
    let result = this.resultMap.get(names);
    if (!result) {
      result = new BehaviorSubject({});
      this.resultMap.set(names, result);
    }

    let events = this.eventsMap.get(names);
    if (!events) {
      events = new Subject();
      events
        .pipe(
          throttleTime(3000),
          mergeMap((name2: string) => from(this.getData(name2))),
          distinctUntilChanged((a: object, b: object) => {
            return JSON.stringify(a) === JSON.stringify(b);
          }),
        )
        .subscribe(result);
      this.eventsMap.set(names, events);
    }

    events.next(names);
    return result;
  }

  /**
   * 清除权限管理
   */
  public clear() {
    this.resultMap.clear();
    this.eventsMap.clear();
  }
}

const manager = new PermissionManager();
export default manager;
